import LogoContainer from './Logo.container';

export default LogoContainer;
